import { createFileRoute, notFound } from '@tanstack/react-router';

import { lazyScreen } from '@/shared/screen/lazy-screen';

// /dev/pix-med-admin (só dev): fora do DEV a rota não existe e a página não entra no bundle.
export const Route = createFileRoute('/dev/pix-med-admin/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'PixMedAdminDevPage') : () => null,
});
